export default {"src":"/_next/static/media/star.a5b1a39e.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};